module.exports = __webpack_public_path__ + "style/img/PD_icon_BossDI 1.ef031f51.png";